import cn from 'clsx';
import { FC } from 'react';

import { TextButtonModel } from '../../../types';
import TextButton from '../../Button/Text/TextButton';

import s from './SectionTitle.module.scss';

type SectionTitleSizeType = 'small' | 'medium' | 'large';

export interface SectionTitleProps {
  title: string;
  subText?: string;
  size?: SectionTitleSizeType;
  className?: string;
  button?: TextButtonModel;
}

const SectionTitle: FC<React.PropsWithChildren<React.PropsWithChildren<SectionTitleProps>>> = ({ size = 'medium', title, subText, button, className }) => {
  return (
    <div className={cn(s.wrap, s[size], className)}>
      <div className={cn(s.innerWrap, s[size])}>
        <h1 className={cn(s.title, s[size])}>{title}</h1>
        {subText && <p className={cn(s.subtext, s[size])}>{subText}</p>}
      </div>

      {button && (
        <TextButton size={size === 'large' ? 'default' : 'small'} state={button.state} icon={button?.icon} onClick={button.onClick}>
          {button.label}
        </TextButton>
      )}
    </div>
  );
};

export default SectionTitle;
